const BASE_HEADER_NAMES = ['content-type', 'authorization', 'x-tenant-id'];

export const buildRequestHeaders = (
  token?: string,
  tenantId?: string | null,
  extra?: Record<string, string>,
): Record<string, string> => {
  // fetch skleja nagłówki bez względu na wielkość liter, więc samo nadpisanie
  // klucza nie wystarcza — nagłówki bazowe usuwamy z `extra` po nazwie.
  const allowedExtra = Object.fromEntries(
    Object.entries(extra ?? {}).filter(
      ([name]) => !BASE_HEADER_NAMES.includes(name.toLowerCase()),
    ),
  );
  const header: Record<string, string> = {
    ...allowedExtra,
    'Content-Type': 'application/json',
  };
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }
  if (tenantId) {
    header['X-Tenant-Id'] = tenantId;
  }
  return header;
};
